import React from 'react';
import styles from './PostHelp.module.scss';

const PostHelp = ({ points, ...rest }) => {
  if (points.length === 0) {
    return <noscript />;
  }

  return (
    <div>
      <hr className="hidden-md hidden-lg hidden-xl" />
      <ul className={styles.container} {...rest}>
        {points.map((point, idx) => (
          <li key={idx}>{point}</li>
        ))}
      </ul>
    </div>
  );
};

export default PostHelp;
